/**
* Created by MARCIANO_8
* Marciano Digital Agency
* www.marciano.com.mx
* Date: 15/03/2018.
*
* layouts-create-view Vue Component
*/
<template>
  <form-modal
    :hide-secondary-button="true"
    primary-button-label="Editar periodo"
    modal-title="Editar periodo"
    @closeModal="onCloseModal"
    @primaryButtonClick="onSave">
    <div class="content">
      <periods-form
        ref="form"
        :old="oldPeriod"/>
    </div>
  </form-modal>
</template>

////////////////////////////////////////////
//                                  SCRIPT
////////////////////////////////////////////
<script>
import FormModal from '@/components/_shared/form-modal'
import PeriodsForm from '@/modules/periods/periods-form'
import PeriodsGuards from '@/guards/periods.guards'
import {mapGetters} from 'vuex'

export default {
  name: 'PeriodsCreateView',
  components: {FormModal, PeriodsForm},
  computed: {
    ...mapGetters('periods', {
      oldPeriod: 'item'
    })
  },
  methods: {
    onCloseModal () {
      this.$router.push({name: 'periods'})
    },
    onSave () {
      this.$refs.form.onSubmit()
    }
  },
  beforeRouteEnter: PeriodsGuards.onEdit
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
  .content{
    padding: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/views/app/periods/periods-edit-view.vue